import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-pause-circle",
  "use": "icon-pause-circle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-pause-circle\" id=\"icon-pause-circle\"><circle cx=\"12\" cy=\"12\" r=\"10\" /><line x1=\"10\" y1=\"15\" x2=\"10\" y2=\"9\" /><line x1=\"14\" y1=\"15\" x2=\"14\" y2=\"9\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol